export const environment = {

  baseURL: 'https://asociadosmontepio.gruposca.net/API-1/',
  env: 'test'
};
